import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Total ")
const _hoisted_8 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_13 = { class: "p-grid" }
const _hoisted_14 = { class: "p-col" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1)
const _hoisted_17 = { class: "p-col" }
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1)
const _hoisted_20 = { class: "p-grid" }
const _hoisted_21 = { class: "p-col" }
const _hoisted_22 = { class: "p-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Payment Method", -1)
const _hoisted_24 = { class: "p-col" }
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Cashier", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-primary px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-file-excel",
              class: "p-button-success px-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportCSVWithFooter()))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.searchFilters.type) + "Purchase Returns Report", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DataTable, {
          value: _ctx.rList,
          lazy: true,
          first: _ctx.goToFirstLink,
          "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
          firstModifiers: { sync: true },
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
          resizableColumns: true,
          rows: _ctx.limit,
          totalRecords: _ctx.totalRecords,
          onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
          loading: _ctx.loading,
          autoLayout: true,
          scrollHeight: "70vh",
          responsiveLayout: "scroll",
          scrollable: true,
          ref: "dt"
        }, {
          empty: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "branchName",
              header: "Branch"
            }, {
              footer: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "receiptDate",
              header: "Date"
            }),
            _createVNode(_component_Column, {
              field: "receiptNo",
              header: "Receipt No"
            }),
            _createVNode(_component_Column, {
              field: "billNo",
              header: "Purchase Receipt No"
            }),
            _createVNode(_component_Column, {
              field: "supplierName",
              header: "Supplier"
            }),
            _createVNode(_component_Column, {
              field: "userName",
              header: "Cashier"
            }),
            _createVNode(_component_Column, {
              field: "gross",
              header: "Total Gross"
            }, {
              footer: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(_ctx.totalGross)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "discount",
              header: "Total Discount"
            }, {
              footer: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(_ctx.totalDiscounts)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "totalBill",
              header: "Purchase Price"
            }, {
              footer: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(_ctx.totalSubTotal)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "paymentMethod",
              header: "Payment Method"
            }),
            _createVNode(_component_Column, {
              field: "paidAmount",
              header: "Amount"
            }, {
              footer: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(_ctx.totalPaidAmount)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "paidDate",
              header: "Txn Date"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.paidDate)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "first", "rows", "totalRecords", "loading"])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadList(0)))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.paymentMethodID,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.paymentMethodID) = $event)),
                  options: _ctx.paymentMethods,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.cashierID,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.cashierID) = $event)),
                  options: _ctx.cashiers,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}